module.exports = __webpack_public_path__ + "static/media/magic.0248ffa1.svg";